import React from 'react';
import { Route } from 'react-router-dom';
import Home from './pages/Home';
import Settings from './pages/Settings';
import Edit from './pages/Edit'
import OrdersWithImage from './pages/Orders-with-image'

const App = () => {
    return (
        <>
            {console.log('dev')}
            <Route exact path="/">
                <Home />
            </Route>
            <Route exact path="/settings">
                <Settings />
            </Route>
            <Route exact path="/orders-with-image">
                <OrdersWithImage />
            </Route>
            <Route exact path="/edit">
                <Edit />
            </Route>
        </>
    )
}

export default App;